import React, { useEffect, useState } from "react";
import PopupAHSF from "../../Components/PopupAHSF";
import TableAHSF from "../../Components/TableAHSF";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import {
  DeletePR_LessonsLearnedById,
  GetSpecificRowNoteLessonsLearned,
} from "../../Redux/Reducers/ReportStage/LessonsLearned";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";

const JobOpportunitiesSummary = (props) => {
  const dispatch = useDispatch();
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [popUpBodyOPjectDataAddStatus, setpopUpBodyOPjectDataAddStatus] =
    useState(false);
  const [pR_LessonsLearnedId, setpR_LessonsLearnedId] = useState(null);
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      OneSpecificRowNoteLessonsLearned:
        state.LessonsLearned.OneSpecificRowNoteLessonsLearned,
    };
  });

  console.log(state.OneSpecificRowNoteLessonsLearned, "stateeee");

  let { stageGuid } = useParams();

  stageGuid = decryptToken(stageGuid);
  useEffect(() => {
    dispatch(
      GetSpecificRowNoteLessonsLearned({
        pR_ReportsStagesGuid: stageGuid,
        pR_NotesTableId: "455265a0-6d80-41ce-9efa-cce98a4dac90",
      })
    );
    console.log(stageGuid, "aaaaaa");
  }, []);

  //   const shouldDisableFields = false;
  const RequestAccessor = [
    {
      KeyName: "FullTimeTotal",
      ShowStatus: true,
      NmaeColumn: " دوام كامل",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "PartTimeTotal",
      ShowStatus: true,
      NmaeColumn: " دوام جزئي",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "ServicesTotal",
      ShowStatus: true,
      NmaeColumn: "عقد خدمات / عقد استشارة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "VolunteerTotal",
      ShowStatus: true,
      NmaeColumn: " عمل تطوعي",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "all",
      ShowStatus: true,
      NmaeColumn: " العدد الكلي  للوظائف",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const RequestAccessor2 = [
    {
      KeyName: "femaelTotal",
      ShowStatus: true,
      NmaeColumn: "  عدد الوظائف للإناث",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "maelTotal",
      ShowStatus: true,
      NmaeColumn: "  عدد الوظائف للذكور",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const OtherMainBtns = [
   
  
  ];

  const RequestsColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataAddStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div> </div>,

    title: "الدروس المستفادة",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },

    componentBody: <div></div>,

    title: "الدروس المستفادة",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"pR_LessonsLearnedId"}
        valueButtonAction={"pR_LessonsLearnedId"}
        URL={`api/JobOpportunitiesDuringProject/GetPR_JobOpportunitiesDuringProjectListSummary`}
        UrlBody={{
          specificOrMulti: true,
          stageGuid: props.pR_ReportsStagesGuid,
          reportGuid: props.reportId,
          applicationInfoGuid: "string",
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={" فرص العمل التي تم توفيرها خلال فترة تنفيذ المشروع"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={false}
        paginationHide={false}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"الدروس المستفادة"}
        popUpBody={<></>}
      />
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"pR_LessonsLearnedId"}
        valueButtonAction={"pR_LessonsLearnedId"}
        URL={`api/JobOpportunitiesDuringProject/GetPR_JobOpportunitiesDuringProjectListSummary`}
        UrlBody={{
          specificOrMulti: true,
          stageGuid: props.pR_ReportsStagesGuid,
          reportGuid: props.reportId,
          applicationInfoGuid: "string",
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor2}
        titelTable={" فرص العمل التي تم توفيرها خلال فترة تنفيذ المشروع"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        tableHeader={true}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"الدروس المستفادة"}
        popUpBody={<></>}
      />
    </>
  );
};

export default JobOpportunitiesSummary;
